<template>
  <div>

    <Dialog :visible.sync="exibirModal" :header="titulo" :modal="true" :style="{ width: '40vw' }" @hide="fechar">
      <div v-if="itemPendente">
        <label class="p-text-bold">{{ dados.solicitacao.funcionario.nomecc }}</label>
        <hr>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-6">
            <label>Data da Solicitação</label>
            <InputText class="input-readonly" v-model="dados.solicitacao.data" readonly />
          </div>
          <div class="p-field p-col-6">
            <label>Data do Ponto</label>
            <InputText class="input-readonly" v-model="dados.solicitacao.dataPonto" readonly />
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Evento</label>
            <InputText class="input-readonly" v-model.trim="itemPendente.infoCampo1" readonly />
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Justificativa</label>
            <InputText class="input-readonly" v-model.trim="itemPendente.justificativa.descricao" readonly />
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Ajuste De</label>
            <InputText class="input-readonly" v-model.trim="dataHoraDe1" readonly />
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Ajuste Até</label>
            <InputText class="input-readonly" v-model.trim="dataHoraAte1" readonly />
          </div>
        </div>

        <div class="p-fluid p-formgrid p-grid" v-if="alteracao">
          <div class="p-field p-col-12 p-mt-3 p-mb-0">
            <hr class="p-mt-0">
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Ajuste De <span class="p-text-bold">(Novo)</span></label>
            <InputText class="input-readonly" v-model.trim="dataHoraDe2" readonly />
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label>Ajuste Até <span class="p-text-bold">(Novo)</span></label>
            <InputText class="input-readonly" v-model.trim="dataHoraAte2" readonly />
          </div>
        </div>

        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
            <label class="p-text-bold">Ação</label>
            <Dropdown v-model="acaoSelecionada" :options="acoes" optionLabel="nome" optionValue="id"
              placeholder="Selecione" appendTo="body" :disabled="!exibirBotoes"
              :class="!exibirBotoes ? 'input-readonly' : ''" />
          </div>
          <div class="p-field p-col-12 p-md-12" v-if="acaoSelecionada == naoAprovado">
            <label class="p-text-bold">Observação</label>
            <Textarea v-model.trim="observacaoNaoAprovado" rows="3" cols="30"
              :class="!exibirBotoes ? 'input-readonly' : ''" :disabled="!exibirBotoes" />
          </div>
        </div>
      </div>
      <template #footer>
        <div class="p-d-flex p-jc-end">
          <div v-if="exibirBotoes">
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirModal = false" />
            <Button label="Salvar" icon="pi pi-check" @click="salvar" />
          </div>
        </div>
      </template>
    </Dialog>

  </div>
</template>
  
<script>
import ControlePontoService from '@/service/ControlePontoService.js';
import { exibirMensagemSis, exibirMensagem, acoesSolicitacoesPendentes, clonar } from '@/global';
import { mapGetters } from 'vuex';

export default {
  ocorrenciaService: null,
  controlePontoService: null,
  props: {
    callback: Function,
  },
  data() {
    return {
      titulo: 'Solicitação',
      naoAprovado: 'Não Aprovado',
      exibirModal: false,
      itemPendente: null,
      observacaoNaoAprovado: '',
      dados: null,
      acaoSelecionada: '',
      acoes: acoesSolicitacoesPendentes,
      exibirBotoes: false,
      alteracao: false,
      dataHoraDe1: '',
      dataHoraAte1: '',
      dataHoraDe2: '',
      dataHoraAte2: '',
    }
  },
  methods: {
    ...mapGetters('sessao', ['getDadosRequisicao']),
    /**
     * 
     * @param {*} dados 
     */
    processar(dados) {
      this.controlePontoService = new ControlePontoService();
      this.dados = dados;
      this.buscarItemSolicitacao();
    },
    /**
    * 
    * @param {*} solicitacao 
    */
    buscarItemSolicitacao() {
      let requisicao = {
        idSolicitacao: this.dados.solicitacao.id,
        idFuncionario: this.dados.solicitacao.funcionario.id,
        dataPonto: this.formartarStrData(this.dados.solicitacao.dataPonto, 'US'),
        usuarioRequisicao: { ...this.getDadosRequisicao() }
      };
      this.controlePontoService.buscarItemSolicitacaoAjusteParcial(requisicao)
        .then(resp => {
          this.itemPendente = resp.data;
          const partes = this.itemPendente.infoCampo2.split('_');
          this.dataHoraDe1 = this.formartarStrDataHora(partes[0], 'BR');
          this.dataHoraAte1 = this.formartarStrDataHora(partes[1], 'BR');
          const solicitacao = this.dados.solicitacao;
          if (solicitacao.status === 'Pendente' && this.dados.permissaoEditar) {
            this.exibirBotoes = true;
          } else {
            this.acaoSelecionada = solicitacao.status;
          }
          if (!solicitacao.observacao) {
            this.dados.solicitacao.observacao = '';
          }
          this.observacaoNaoAprovado = solicitacao.observacao;
          if (this.itemPendente.acao === 'ATUALIZAR') {
            this.titulo = 'Solicitação | Ajuste Parcial | Atualizar';
            this.alteracao = true;
            const partes = this.itemPendente.infoCampo3.split('_');
            this.dataHoraDe2 = this.formartarStrDataHora(partes[0], 'BR');
            this.dataHoraAte2 = this.formartarStrDataHora(partes[1], 'BR');
          } else if (this.itemPendente.acao === 'EXCLUIR') {
            this.titulo = 'Solicitação | Ajuste Parcial | Excluir';
            this.alteracao = false;
          } else {
            this.titulo = 'Solicitação | Ajuste Parcial | Novo';
            this.alteracao = false;
          }
          this.exibirModal = true;
        })
        .catch(erro => { exibirMensagem(this, erro) });
    },
    /**
     * 
     */
    salvar() {
      if (this.acaoSelecionada == '') {
        exibirMensagemSis(this, 'Selecione uma ação', true);
        return;
      }
      if (this.acaoSelecionada === this.naoAprovado
        && this.observacaoNaoAprovado === '') {
        exibirMensagemSis(this, 'Informe um texto breve na observação', true);
        return;
      }
      let solicitacao = clonar(this.dados.solicitacao);
      delete solicitacao.funcionario;
      solicitacao.status = this.acaoSelecionada;
      solicitacao.observacao = this.observacaoNaoAprovado;
      solicitacao['usuarioAprovacao'] = this.dados.requisicao.usuarioRequisicao.usuario.nome;
      if (this.itemPendente.acao == 'NOVO') {
        this.resolverPendenciaNovo(solicitacao);
      } else if (this.itemPendente.acao == 'ATUALIZAR') {
        this.resolverPendenciaAlteracao(solicitacao);
      } else if (this.itemPendente.acao == 'EXCLUIR') {
        this.resolverPendenciaExcluir(solicitacao);
      }
    },
    /**
     * 
     */
    resolverPendenciaNovo(solicitacaoAtualizar) {
      const dataHora = this.itemPendente.infoCampo2.split('_');
      const dataHoraDe = dataHora[0].split(' ');
      const dataHoraAte = dataHora[1].split(' ');
      const novaRequisicao = {
        solicitacao: solicitacaoAtualizar,
        mes: this.dados.requisicao.mes,
        ano: this.dados.requisicao.ano,
        justificativa: this.itemPendente.justificativa,
        idPonto: this.itemPendente.idReferencia1,
        idEventoAjustar: this.itemPendente.idReferencia2,
        idFuncionario: this.dados.solicitacao.funcionario.id,
        ajusteParcial: {
          codigoEvento: this.itemPendente.codigoEventoPendente,
          diaInicio: dataHoraDe[0],
          horaInicio: dataHoraDe[1],
          diaFinal: dataHoraAte[0],
          horaFinal: dataHoraAte[1],
        },
        usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
      }
      this.controlePontoService.resolverPendenciaAjusteParcialNovo(novaRequisicao)
        .then(resp => {
          this.fechar();
          exibirMensagem(this, resp);
          this.callback(solicitacaoAtualizar);
        })
        .catch(erro => { exibirMensagem(this, erro) });
    },
    /**
     * 
     */
    resolverPendenciaAlteracao(solicitacaoAtualizar) {
      const dataHora = this.itemPendente.infoCampo3.split('_');
      const dataHoraDe = dataHora[0].split(' ');
      const dataHoraAte = dataHora[1].split(' ');
      const novaRequisicao = {
        solicitacao: solicitacaoAtualizar,
        mes: this.dados.requisicao.mes,
        ano: this.dados.requisicao.ano,
        justificativa: this.itemPendente.justificativa,
        idPonto: this.itemPendente.idReferencia1,
        idEventoAbonado: this.itemPendente.idReferencia3,
        idFuncionario: this.dados.solicitacao.funcionario.id,
        ajusteParcial: {
          id: this.itemPendente.idReferencia2,
          codigoEvento: this.itemPendente.codigoEventoPendente,
          diaInicio: dataHoraDe[0],
          horaInicio: dataHoraDe[1],
          diaFinal: dataHoraAte[0],
          horaFinal: dataHoraAte[1],
        },
        usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
      }
      this.controlePontoService.resolverPendenciaAjusteParcialAlterar(novaRequisicao)
        .then(resp => {
          this.fechar();
          exibirMensagem(this, resp);
          this.callback(solicitacaoAtualizar);
        })
        .catch(erro => { exibirMensagem(this, erro) });
    },
    /**
     * 
     */
    resolverPendenciaExcluir(solicitacaoAtualizar) {
      const novaRequisicao = {
        solicitacao: solicitacaoAtualizar,
        mes: this.dados.requisicao.mes,
        ano: this.dados.requisicao.ano,
        idPonto: this.itemPendente.idReferencia1,
        idEventoAjustado: this.itemPendente.idReferencia2,
        idFuncionario: this.dados.solicitacao.funcionario.id,
        usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
      }
      this.controlePontoService.resolverPendenciaAjusteParcialExcluir(novaRequisicao)
        .then(resp => {
          this.fechar();
          exibirMensagem(this, resp);
          this.callback(solicitacaoAtualizar);
        })
        .catch(erro => { exibirMensagem(this, erro) });
    },
    /**
     * 
     * @param {*} strData 
     * @param {*} formato 
     */
    formartarStrData(strData, formato) {
      if (formato == 'BR') {
        let partes = strData.split('-');
        return partes[2] + '/' + partes[1] + '/' + partes[0];
      }
      let partes = strData.split('/');
      return partes[2] + '-' + partes[1] + '-' + partes[0];
    },
    /**
     * 
     * @param {*} strData 
     * @param {*} formato 
     */
    formartarStrDataHora(strData, formato) {
      if (formato == 'BR') {
        let dataHora = strData.split(' ');
        let partes = dataHora[0].split('-');
        return partes[2] + '/' + partes[1] + '/' + partes[0] + ' ' + dataHora[1];
      }
      let dataHora = strData.split(' ');
      let partes = dataHora[0].split('/');
      return partes[2] + '-' + partes[1] + '-' + partes[0] + ' ' + dataHora[1];
    },
    /**
     * 
     */
    fechar() {
      this.exibirModal = false;
      this.itemPendente = null;
      this.observacaoNaoAprovado = '';
      this.dados = null;
      this.acaoSelecionada = '';
      this.exibirBotoes = false;
      this.controlePontoService = null;
      this.dataHoraDe1 = '';
      this.dataHoraAte1 = '';
      this.dataHoraDe2 = '';
      this.dataHoraAte2 = '';
      this.titulo = 'Solicitação';
      this.novo = false;
      this.alteracao = false
    }
  }
}
</script>
  
<style scoped>
.input-readonly {
  background-color: #F2F2F2;
}
</style>